import { combineReducers } from 'redux'

import isOpen from './isOpen'
import notification from './notification'

export default combineReducers({
  isOpen,
  notification,
})
